$(document).ready(function () {
	$('.tooltip').each(function (index, el) {
		var $this = $(this);

		$this
			.append('<sup class="tooltip-number">' + (index + 1) + '</sup>');
		$('.content')
			.append('<p class="footnotes"><sup>' + (index + 1) + '</sup> ' + $this.find('.tooltip__text').text() + '</p>');

		$this.find('.tooltip__text').wrapInner('<span>');
	});
});



/** WEBPACK FOOTER **
 ** ./frontend/components/tooltips/tooltips.js
 **/